// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileMenuIcon_wrapper__iUSzB","svg":"MobileMenuIcon_svg__eI7L3","notificationCount":"MobileMenuIcon_notificationCount__yW7aC"};